module.exports = __webpack_public_path__ + "static/media/AGS Logo.fc45f1c9.jpeg";